'use client';

import { useFacebookPixelEvents } from '@/hooks/use-facebook-pixel-events';
import { useAuth } from '@/lib/auth/use-auth';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function FacebookPixelTrackPageView() {
  const { trackPageView } = useFacebookPixelEvents();
  const { user } = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    trackPageView(
      {
        email: user?.email,
        phone: user?.phone,
      },
      {
        page_url: pathname,
      },
    );
  }, [pathname, trackPageView, user]);

  return null;
}
